import React, {useDeferredValue, useState} from "react";
import PageHeader from "../../components/PageHeader";
import DataTable from 'react-data-table-component'
import EditCompanyModal from './edit';
import AddCompanyModal from './Add';
import ViewModal from './View';
import { Button, Collapse, Form } from "react-bootstrap";
import {customTableStyles, deleteConfirmation} from "../../utils";
import Filter from "./Filter";
import useLiveDataTable from "../../hooks/useLiveDataTable";
import CustomPagination from "../../components/CustomPagination";
import {useGetJobQuery, useRemoveJobMutation} from "../../redux/services/JobService";
import {useGetBrokerQuery, useRemoveBrokerMutation} from "../../redux/services/BrokerService";

const BrokersPage = () => {
    const {
        currentPage,
        perPage,
        q,
        searchQuery,
        setSearchQuery,
        handlePageChange,
        handlePerPageChange,
        handleSearchChange,
        onSearchKeyHandler,
        handleSearchBy,
        searchBy,
    } = useLiveDataTable();

    const [isShow, setIsShow] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [isView, setIsView] = useState(false)
    const [open, setOpen] = useState(false);
    const [query, setQuery] = useState(null)
    const params = useDeferredValue(query)

    const [removeRequest] = useRemoveBrokerMutation()

    const { data: data2, isFetching, refetch } = useGetBrokerQuery({ pagination: `?page=${currentPage}&per_page=${perPage}&search_by=${searchBy}&search=${q}${params?.id ? '&created_at=' + params?.id : ''}` })
    const drivers = data2?.response?.data?.data
    const total = data2?.response?.data?.total;


    const handleAdd = () => {
        setIsEdit(null)
        setIsShow(true)
        // reset()
    }

    const handleEdit = (items) => {
        setIsEdit(items)
        setIsShow(true)
    }

    const handleView = (items) => {
        setIsEdit(items)
        setIsView(true)
    }

    console.log('open', params)



    return (
        <>
            <PageHeader name="Broker" />
            <div className="main-container container-fluid">
                {" "}
                {/* Start::row-1 */}
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card custom-card">
                            <div className="card-header w-100">
                                <div className="row w-100 m-0">
                                    <div className="col-auto p-0 d-flex">
                                        <Button
                                            className="btn btn-primary"
                                            onClick={handleAdd}
                                        >
                                            Add Broker
                                        </Button>
                                    </div>
                                    <div className="col-auto p-0 ms-2">
                                        <Button
                                            className="btn btn-primary  "
                                            onClick={() => setOpen(!open)} // Toggle collapse
                                            aria-controls="collapse-inputs"
                                            aria-expanded={open}
                                        >
                                            <i className="ri-filter-2-fill" />
                                        </Button>
                                    </div>
                                    <div className="col-lg-3 col-5 p-0 ms-auto">
                                        <div className="input-group m-0">
                                            <span
                                                className="input-group-text bg-transparent border text-primary" id="basic-addon1">
                                                <i className="ri-search-line" />
                                            </span>
                                            <input
                                                className="form-control" type="text" placeholder="Search Here..."
                                                aria-describedby="basic-addon1"
                                                value={searchQuery}
                                                onKeyUp={(e) => onSearchKeyHandler(e)}
                                                onChange={(e) => setSearchQuery(e.target?.value)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Collapse in={open}>
                                <div className="w-100">
                                    <Filter setQuery={setQuery} />
                                </div>
                            </Collapse>
                            <div className="card-body">
                                <CustomPagination
                                    isFetching={isFetching}
                                    data={drivers}
                                    total={total}
                                    onChangePage={handlePageChange} // Handle page change
                                    onChangeRowsPerPage={handlePerPageChange} // Handle per page change
                                    paginationDefaultPage={currentPage} // Set the current page


                                    columns={[
                                        {
                                            name: 'Broker Name',
                                            selector: row => row.broker_name,
                                            sortable: true,
                                        },
                                        {
                                            name: 'Broker Email',
                                            selector: row => row.broker_email,
                                            sortable: true,
                                        },
                                        {
                                            name: 'Phone Number',
                                            selector: row => row.phone_number,
                                            sortable: true,
                                        },
                                        {
                                            name: 'Description',
                                            selector: row => row.description,
                                            sortable: true,
                                        },
                                        {
                                            name: 'Created At',
                                            selector: row => row.created_at,
                                            sortable: true,
                                        },
                                        {
                                            name: 'Actions',
                                            cell: (row) => {
                                                return (
                                                    <div className="hstack gap-1 fs-1">
                                                        <button
                                                            aria-label="view"
                                                            onClick={() => handleView(row)}
                                                            className="btn btn-icon btn-sm btn-primary-light btn-wave waves-effect waves-light"
                                                        >
                                                            <i className="ri-eye-fill" />
                                                        </button>
                                                        <button
                                                            aria-label="edit"
                                                            // onClick={() => navigate(`/jobs/edit/${row?.id}`, { state: { isEdit: row } })}
                                                            onClick={() => handleEdit(row)}
                                                            className="btn btn-icon btn-sm btn-info-light btn-wave waves-effect waves-light"
                                                        >
                                                            <i className="ri-edit-line" />
                                                        </button>
                                                        <a
                                                            aria-label="delete"
                                                            onClick={() => deleteConfirmation(() => removeRequest(row?.id))}
                                                            className="btn btn-icon btn-sm btn-danger-light btn-wave waves-effect waves-light"
                                                        >
                                                            <i className="ri-delete-bin-7-line" />
                                                        </a>
                                                    </div>
                                                )
                                            },
                                            ignoreRowClick: true,
                                            allowOverflow: true,
                                            button: true,
                                            width: '220px'
                                        },
                                    ]}

                                />
                            </div>
                        </div>
                        {isShow && (
                            <AddCompanyModal
                                show={isShow}
                                handleClose={() => {
                                    setIsShow(false)
                                    setIsEdit(null)
                                }}
                                isEdit={isEdit}
                            />
                        )}
                        {/* <EditCompanyModal
                            show={isEdit}
                            handleClose={() => setIsEdit(false)}
                        /> */}
                        {isView && (
                            <ViewModal
                                show={isView}
                                handleClose={() => {
                                    setIsView(false)
                                    setIsEdit(null)
                                }}
                                isEdit={isEdit}
                            />
                        )}

                    </div>
                </div>
            </div>
        </>
    )
}

export default BrokersPage